/* eslint-disable no-console */
import _isPlainObject from 'lodash/isPlainObject';
import { captureException, captureMessage } from '../utils/logrocket';

function addLocationToObjectIfMissing(data) {
  try {
    return { location: window.location.href, ...data };
    // the only possible errors here should be some version of "window/location doesn't exist"
  } catch {
    return data;
  }
}

function getStackTrace() {
  try {
    throw new Error('Manually thrown error for Stack Trace getting');
  } catch (error) {
    return error.stack;
  }
}

function addStackTraceToObjectIfMissing(data) {
  const stackTrace = getStackTrace();

  return { stackTrace, ...data };
}

function prepareDataForReporting(data) {
  let asObject = data;
  if (!_isPlainObject(data)) {
    asObject = { data };
  }

  const withLocation = addLocationToObjectIfMissing(asObject);
  const withStackTrace = addStackTraceToObjectIfMissing(withLocation);

  return withStackTrace;
}

export function reportError(error, data) {
  const dataWithLocation = prepareDataForReporting(data);

  if (process.env.NODE_ENV === 'production') {
    window?.DD_RUM?.addError?.(error, dataWithLocation || undefined);
    captureException(error, { extra: dataWithLocation || undefined });
  } else if (process.env.NODE_ENV === 'development') {
    console.error(error, dataWithLocation);
  }
}

export function reportWarning(warning, data) {
  const dataWithLocation = prepareDataForReporting(data);

  if (process.env.NODE_ENV === 'production') {
    window?.DD_RUM?.addError?.(warning, { severity: 'warning', ...dataWithLocation });
    captureMessage(warning, { extra: dataWithLocation || undefined });
  } else if (process.env.NODE_ENV === 'development') {
    console.warn(`🚨 WARNING 🚨\n`, warning, dataWithLocation || undefined);
  }
}
